export default "__VITE_ASSET__BIfAPgiR__"